const getCompanyOptionData = (company, t) => {
  if (company === 'uid-not-found') {
    return { name: t('company.noCompany'), address: t('company.noCompanySubtitle') };
  }

  const name = company.currentName;
  let address = '';
  if (company.mainAddress) {
    address = `${company.mainAddress.street ? company.mainAddress.street + ',' : ''} ${
      company.mainAddress.zip ? company.mainAddress.zip + ',' : ''
    } ${company.mainAddress.city ? company.mainAddress.city : ''}`;
  }

  return { name, address };
};

export default getCompanyOptionData;
